export default __webpack_public_path__ + "static/media/lesnik_winter_b_10.ea96a76d.svg";